// The dev env points at a server on `localhost`. Swapping in the page's own hostname makes every
// hostname its own user: alice.localhost:5184 talks to alice.localhost:9495, and the browser keeps
// separate localStorage and (host-only) cookies for each. It also lets a phone on the LAN reach the
// dev server via the machine's IP. Production hosts don't say `localhost` and are left alone.
const onPageHost = (url: string) => {
  if (!url || typeof location === "undefined") return url;
  return url.replace(/^(\w+:\/\/)localhost(?=[:/]|$)/, `$1${location.hostname}`);
};

export const httpServerHost = onPageHost(import.meta.env.VITE_HTTP_SERVER_HOST);
export const wsServerHost = onPageHost(import.meta.env.VITE_WS_SERVER_HOST);
export const httpAssetHost = onPageHost(import.meta.env.VITE_HTTP_ASSET_HOST);
